module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-layout', [_c('v-flex', [_c('h3', {
    staticClass: "headline"
  }, [_vm._v("Take bookings online!")]), _vm._v(" "), _c('p', {
    staticClass: "subheading"
  }, [_vm._v("\n          Your clients can book online from your free AppointmentGuru website, your booking widget or via the mobile app. This frees up your time with less phone calls and messages for appointments.\n          ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "hidden-xs-only": ""
    }
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "alt": "Example website and app listing",
      "width": "170",
      "src": "https://media-appointmentguru.s3.amazonaws.com/media/practitioner/logo/170_get-online-example.png"
    }
  })])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n        Configure how you would like your customers to book\n      ")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Booking widget")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.bookingwidget))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Share the direct link to let someone book online with you, or embed it on your website\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            View\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-dialog', {
    attrs: {
      "width": "350"
    },
    model: {
      value: (_vm.showembedcode),
      callback: function($$v) {
        _vm.showembedcode = $$v
      },
      expression: "showembedcode"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n                Copy this code to embed a booking widget in your website\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-textarea', {
    staticStyle: {
      "font-size": "small"
    },
    attrs: {
      "outlined": "",
      "outline": "",
      "readonly": "",
      "persistent-hint": "",
      "label": "Embed this in your website",
      "height": "200",
      "hint": "Paste this code where you would like to embed the booking widget"
    },
    model: {
      value: (_vm.embedCode),
      callback: function($$v) {
        _vm.embedCode = $$v
      },
      expression: "embedCode"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('copy-text-field', {
    staticClass: "mt-4",
    attrs: {
      "text-to-copy": _vm.bookingwidget,
      "label": "Share your online booking form",
      "hint": "Share this link to enable your clients to easily book online with you"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showembedcode = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.bookingwidget,
      "target": "_blank",
      "small": "",
      "text": "",
      "flat": ""
    }
  }, [_vm._v("\n                  Show widget\n                  "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showembedcode = true
      }
    }
  }, [_c('v-icon', [_vm._v("code")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            Embed\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.saveRequest.loading
    },
    model: {
      value: (_vm.webEnabled),
      callback: function($$v) {
        _vm.webEnabled = $$v
      },
      expression: "webEnabled"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your website ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Your website URL:\n            "), _c('a', {
    attrs: {
      "href": _vm.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.website))])]), _vm._v(" "), (!_vm.webPublished) ? _c('v-list-tile-sub-title', [_vm._v("\n            Currently disabled. Check the box on the left to enable and configure\n          ")]) : _c('v-list-tile-sub-title', [_vm._v("\n            Configure your website below\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "disabled": !_vm.webPublished,
      "href": _vm.website,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v("\n            View\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("Configure your website")]), _vm._v(" "), (!_vm.webPublished) ? _c('v-alert', {
    attrs: {
      "type": "info",
      "value": true,
      "outline": ""
    }
  }, [_vm._v("\n        You website is currently disabled. You need to enable it in order to configure.\n        "), _c('v-btn', {
    attrs: {
      "loading": _vm.saveRequest.loading,
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.webEnabled = true;
        _vm.save()
      }
    }
  }, [_vm._v("Turn on website")])], 1) : _c('v-text-field', {
    attrs: {
      "outline": "",
      "outlined": "",
      "loading": _vm.actionRequest.loading,
      "error": _vm.actionRequest.status > 399,
      "success": _vm.actionRequest.status === 200,
      "success-messages": _vm.subdomainSuccessMessage,
      "error-messages": _vm.subdomainErrorMessage,
      "label": "Set your website url",
      "prefix": "appt.guru/",
      "append-icon": "save"
    },
    on: {
      "click:append": _vm.setSubdomain,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setSubdomain.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.subdomain),
      callback: function($$v) {
        _vm.subdomain = $$v
      },
      expression: "subdomain"
    }
  }), _vm._v(" "), (_vm.webPublished) ? _c('unsplash-search') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24bcff85","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/Online.vue
// module id = 1359
// module chunks = 9